import React from 'react'
import { Link } from '@inertiajs/react'
import { formatPrice } from '../utils/formatters'

const MAX_VISIBLE_CAPABILITIES = 3

export default function RoomCard({ venue, href, fit, rangeLabel, partySizeLabel }) {
  const capabilities = venue.capabilities || []
  const hiddenCount = capabilities.length - MAX_VISIBLE_CAPABILITIES

  return (
    <Link
      href={href}
      className={`block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow focus:outline-none focus:ring-2 focus:ring-sky-300 ${
        fit === false ? 'opacity-60' : ''
      }`}
    >
      {venue.image_url ? (
        <img src={venue.image_url} alt="" className="w-full h-40 object-cover" />
      ) : (
        <div className="w-full h-40 bg-sky-50" aria-hidden="true" />
      )}

      <div className="p-4">
        <h3 className="text-lg font-bold text-gray-900">{venue.name}</h3>

        {venue.capacity && (
          fit === true ? (
            <p className="text-sm text-emerald-700 mt-1">
              Seats up to {venue.capacity} — fits your {partySizeLabel}
            </p>
          ) : fit === false ? (
            <p className="text-sm text-gray-500 mt-1">
              Up to {venue.capacity} guests — a bit small for {rangeLabel}
            </p>
          ) : (
            <p className="text-sm text-gray-500 mt-1">
              Up to {venue.capacity} guests
            </p>
          )
        )}

        {venue.packages_from_price_pence != null && (
          <p className="text-sm text-sky-900 font-bold mt-1">
            Packages from {formatPrice(venue.packages_from_price_pence)}
          </p>
        )}

        {capabilities.length > 0 && (
          <div className="flex gap-1.5 mt-3 overflow-hidden">
            {capabilities.slice(0, MAX_VISIBLE_CAPABILITIES).map(name => (
              <span
                key={name}
                className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full whitespace-nowrap"
              >
                {name}
              </span>
            ))}
            {hiddenCount > 0 && (
              <span className="text-xs text-gray-400 px-1 py-0.5 whitespace-nowrap">
                +{hiddenCount} more
              </span>
            )}
          </div>
        )}
      </div>
    </Link>
  )
}
